module.exports = __webpack_public_path__ + "img/1_ar.1592b543.png";